import {Divider, Grid, Link, Typography} from "@mui/material";
import * as React from "react";
import {createMarkup} from "../../Shared/utils/textUtilsResources";
import {useTranslation} from "react-i18next";
import {
    EN_CONTACT, EN_LEGAL_TEXT, EN_RESOURCES, EN_SERVICE, EN_TECHNOLOGY,
    EN_US, ENGLISH_MAIN_ROUTE,
    ES_CONTACT,
    ES_LEGAL_TEXT,
    ES_RESOURCES,
    ES_SERVICE,
    ES_TECHNOLOGY,
    ES_US
} from "../../routes/constantsRoutes";
import {useLanguageContext} from "../../context/languageProvider";

const QuickLinks = () => {

    const lang = useLanguageContext();

    const {t} = useTranslation('', {keyPrefix: 'web.footer'})

    const quickFooterLinks = [
        {
            title: t('sections.us'),
            path: lang.language === 'es' ? ES_US : ENGLISH_MAIN_ROUTE + EN_US
        },
        {
            title: t('sections.contact'),
            path: lang.language === 'es' ? ES_CONTACT : ENGLISH_MAIN_ROUTE + EN_CONTACT
        },
        {
            title: t('sections.blog'),
            path: lang.language === 'es' ? ES_RESOURCES : ENGLISH_MAIN_ROUTE + EN_RESOURCES
        },
        {
            title: t('sections.faq'),
            path: lang.language === 'es' ? ES_RESOURCES + '#faqs' : ENGLISH_MAIN_ROUTE + EN_RESOURCES + '#faqs'
        },
        {
            title: t('sections.service'),
            path: lang.language === 'es' ? ES_SERVICE : ENGLISH_MAIN_ROUTE + EN_SERVICE
        },
        {
            title: t('sections.technology'),
            path: lang.language === 'es' ? ES_TECHNOLOGY : ENGLISH_MAIN_ROUTE + EN_TECHNOLOGY
        },
        {
            title: t('sections.legalText'),
            path: lang.language === 'es' ? ES_LEGAL_TEXT : ENGLISH_MAIN_ROUTE + EN_LEGAL_TEXT
        }
    ];

    return (
        <Grid container justifyContent={'center'} className={'footerQuickLinksContainer'}>
            <Grid item xs={10} mb={2}>
                <Typography variant={'body1'} fontSize={'1em'} color={'white'}
                            className={'footerQuickLinksParagraph'}
                            dangerouslySetInnerHTML={createMarkup(t('quickLinks'))}/>
                <Divider style={{ backgroundColor: 'white', width: '20%'}}/>
            </Grid>


            {quickFooterLinks.map((section, index) => {
                return (
                    <Grid key={index} item xs={10} mt={2}>
                        <Link rel={'canonical'} key={'main_page'} href={`${section.path}`}
                              underline="none">
                            <Typography variant={'body1'} fontSize={'1em'} color={'white'}
                                        fontWeight={300} className={'footerQuickLinksParagraph'}
                                        dangerouslySetInnerHTML={createMarkup(section.title)}/>
                        </Link>

                    </Grid>
                );
            })}
        </Grid>
    );
}

export default QuickLinks;
